'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: ', ';\n    padding: 10px;\n'], ['\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: ', ';\n    padding: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    left: -58px;\n    top: 64px;\n    width: 50px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n'], ['\n    position: relative;\n    left: -58px;\n    top: 64px;\n    width: 50px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    margin-right: 8px;\n'], ['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    padding: .25rem .5rem;\n    margin-bottom: 2px;\n    margin-right: 8px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    font-family: \'Poppins\', sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    color: white;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    ', '\n    margin-right: 8px;\n'], ['\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    font-family: \'Poppins\', sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    color: white;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    ', '\n    margin-right: 8px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _colors = require('../../../constants/colors');

var _radius = require('../../../constants/radius');

var _sizes = require('../../../constants/sizes');

var _formEditButton = require('../../../atoms/buttons/formEditButton');

var _formEditButton2 = _interopRequireDefault(_formEditButton);

var _deleteButton = require('../../../atoms/buttons/deleteButton');

var _deleteButton2 = _interopRequireDefault(_deleteButton);

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _divider = require('../../../atoms/divider');

var _divider2 = _interopRequireDefault(_divider);

var _propagatePropsToChildren = require('../../../helpers/propagatePropsToChildren');

var _propagatePropsToChildren2 = _interopRequireDefault(_propagatePropsToChildren);

var _header = require('../../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _formFooter = require('../../../molecules/forms/formFooter');

var _formFooter2 = _interopRequireDefault(_formFooter);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _actionModal = require('../../modals/actionModal');

var _actionModal2 = _interopRequireDefault(_actionModal);

var _alignments = require('../../../constants/alignments');

var _error = require('../../../atoms/icons/error');

var _error2 = _interopRequireDefault(_error);

var _getSectionValidationInfo = require('../../../helpers/getSectionValidationInfo');

var _getSectionValidationInfo2 = _interopRequireDefault(_getSectionValidationInfo);

var _bullet = require('../../../molecules/lists/bullet');

var _bullet2 = _interopRequireDefault(_bullet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FormComponent = (0, _styledComponents2.default)(_container2.default)(_templateObject, _colors.Colors.LightMode, _colors.Colors.DarkMode, _radius.Radius.large);

var ValidationBadgeContainer = _styledComponents2.default.div(_templateObject2);

var ValidationBanner = _styledComponents2.default.div(_templateObject3);

var ValidationBadge = _styledComponents2.default.div(_templateObject4, function (_ref) {
    var alert = _ref.alert;

    switch (alert) {
        case 'warning':
            return 'background: ' + _colors.Colors.Warning + ';';
        case 'error':
        default:
            return 'background: ' + _colors.Colors.Error + ';';
    }
});

var Form = function (_React$Component) {
    _inherits(Form, _React$Component);

    function Form(props) {
        _classCallCheck(this, Form);

        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        _this.state = {
            editing: false,
            valid: {}
        };
        return _this;
    }

    _createClass(Form, [{
        key: 'handleEdit',
        value: function handleEdit() {
            this.setState({
                editing: true
            });
        }
    }, {
        key: 'handleCancel',
        value: function handleCancel() {
            this.setState({
                editing: false
            });

            this.props.cancelEvent();
        }
    }, {
        key: 'handleSave',
        value: function handleSave() {
            this.setState({
                editing: false
            });

            this.props.saveEvent();
        }
    }, {
        key: 'validateForm',
        value: function validateForm() {
            var valid = Object.values(this.state.valid).every(function (value) {
                return value === true;
            });

            if (this.props.validate) {
                return this.props.validate() && valid;
            }

            return valid;
        }
    }, {
        key: 'getDeleteButton',
        value: function getDeleteButton() {
            var intl = this.props.intl;


            return _react2.default.createElement(_actionModal2.default, {
                size: 'small',
                toggle: _react2.default.createElement(_deleteButton2.default, { clickEvent: function clickEvent() {} }),
                items: _react2.default.createElement(_label2.default, { text: intl.formatMessage({ id: 'Form.deleteConfirmation' }) }),
                actionButtons: [{
                    text: intl.formatMessage({ id: 'Form.no' }),
                    clickEvent: function clickEvent() {},
                    primary: false
                }, {
                    text: intl.formatMessage({ id: 'Form.yes' }),
                    clickEvent: this.props.deleteEvent,
                    primary: true
                }]
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _getSectionValidation = (0, _getSectionValidationInfo2.default)(this.props.validationInfo, this.props.pageCode, this.props.sectionCode, this.props.rowId),
                errors = _getSectionValidation.errors,
                warnings = _getSectionValidation.warnings,
                error = _getSectionValidation.error,
                warning = _getSectionValidation.warning;

            var serverErrors = this.props.serverErrors;
            var isServerErrors = serverErrors && serverErrors.length > 0;

            return _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    null,
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 8 },
                        this.props.header && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            (errors > 0 || warnings > 0) && _react2.default.createElement(
                                ValidationBadgeContainer,
                                null,
                                errors > 0 && _react2.default.createElement(
                                    ValidationBadge,
                                    { alert: 'error' },
                                    errors
                                ),
                                warnings > 0 && _react2.default.createElement(
                                    ValidationBadge,
                                    { alert: 'warning' },
                                    warnings
                                )
                            ),
                            _react2.default.createElement(_divider2.default, { top: _sizes.Sizes.sm }),
                            _react2.default.createElement(_header2.default, { size: _sizes.Sizes.md,
                                text: this.props.header,
                                textAlign: _alignments.Alignments.left
                            })
                        )
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 4 },
                        _react2.default.createElement(
                            _container2.default,
                            { fullSize: true,
                                inline: true,
                                verticalAlignment: _alignments.Alignments.bottom,
                                horizontalAlignment: _alignments.Alignments.right
                            },
                            error && !this.state.editing && !errors && !this.props.alwaysEditing && this.props.allowEdit ? _react2.default.createElement(
                                ValidationBanner,
                                null,
                                _react2.default.createElement(_error2.default, { mode: 'error',
                                    size: 24
                                }),
                                _react2.default.createElement(_label2.default, { error: true,
                                    textAlign: _alignments.Alignments.left,
                                    text: error
                                })
                            ) : warning && !this.state.editing && !errors && !this.props.alwaysEditing && this.props.allowEdit ? _react2.default.createElement(
                                ValidationBanner,
                                null,
                                _react2.default.createElement(_error2.default, { mode: 'warning',
                                    size: 24
                                }),
                                _react2.default.createElement(_label2.default, { warning: true,
                                    textAlign: _alignments.Alignments.left,
                                    text: warning
                                })
                            ) : null,
                            this.props.allowEdit && !this.state.editing && !this.props.alwaysEditing && !isServerErrors && _react2.default.createElement(_formEditButton2.default, { clickEvent: function clickEvent() {
                                    return _this2.handleEdit();
                                } }),
                            this.props.allowDelete && !this.state.editing && !this.props.alwaysEditing && this.getDeleteButton()
                        )
                    )
                ),
                _react2.default.createElement(
                    _row2.default,
                    { noguttertop: true },
                    _react2.default.createElement(
                        _column2.default,
                        null,
                        _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(
                                FormComponent,
                                null,
                                this.props.label && _react2.default.createElement(_header2.default, { size: _sizes.Sizes.xs,
                                    top: _sizes.Sizes.md,
                                    bottom: _sizes.Sizes.md,
                                    text: this.props.label,
                                    textAlign: _alignments.Alignments.left
                                }),
                                isServerErrors && _react2.default.createElement(_bullet2.default, { size: _sizes.Sizes.md,
                                    color: _colors.Colors.Error,
                                    references: serverErrors,
                                    bottom: _sizes.Sizes.md
                                }),
                                (0, _propagatePropsToChildren2.default)(this.props.children, {
                                    pageCode: this.props.pageCode,
                                    rowId: this.props.rowId,
                                    sectionCode: this.props.sectionCode,
                                    saveTooltipInfo: this.props.saveTooltipInfo,
                                    reduceTooltipInfoElement: this.props.reduceTooltipInfoElement,
                                    tooltipInfo: this.props.tooltipInfo,

                                    validationInfo: this.props.validationInfo,

                                    editing: (this.state.editing || errors || isServerErrors || this.props.alwaysEditing) && this.props.allowEdit,
                                    sectionUIValidation: function sectionUIValidation(valid) {
                                        return _this2.setState({
                                            valid: _extends({}, _this2.state.valid, valid)
                                        });
                                    }
                                })
                            ),
                            Boolean(this.state.editing || errors || isServerErrors) && !this.props.alwaysEditing && this.props.allowEdit && _react2.default.createElement(_formFooter2.default, {
                                cancelEvent: function cancelEvent() {
                                    return _this2.handleCancel();
                                },
                                saveEvent: function saveEvent() {
                                    return _this2.handleSave();
                                },
                                valid: this.validateForm()
                            })
                        )
                    )
                )
            );
        }
    }]);

    return Form;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(Form);